<template>
  <div class="tw-w-full tw-bg-white tw-py-24">
    <div
      class="tab-view-container tw-w-full tw-flex tw-flex-col"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <span
        class="tw-w-full tw-text-center tw-text-4xl tw-font-bold tw-text-textMain tw-mb-4"
        v-html="$t('首页解决方案标题')"
      ></span>
      <span
        class="tw-w-full tw-text-center tw-text-sm tw-text-textDisabled tw-mb-10"
        >{{ $t("首页解决方案介绍") }}</span
      >

      <b-row>
        <b-col cols="1"> </b-col>
        <b-col cols="10">
          <div class="tw-flex tw-w-full tw-overflow-hidden">
            <div
              class="tw-w-24 tw-flex-none tw-flex tw-items-center tw-justify-end tw-pr-3"
            ></div>

            <div class="tw-flex-1 tw-overflow-hidden tw-flex tw-flex-col">
              <div class="card-container">
                <div
                  class="card"
                  v-for="(item, index) in tabsList"
                  :key="index"
                >
                  <img :src="item.mainImg" :alt="item.name" />
                  <div class="card-content">
                    <div class="tw-flex tw-flex-col title tw-text-white">
                      <span
                        class="tw-h-14 tw-text-xl fontstylewrapmore-2 tw-font-medium"
                        >{{ item.name }}</span
                      >
                      <span
                        class="fontstylewrapmore-3 tw-mt-3 tw-text-sm title-info"
                        >{{ item.intro }}</span
                      >
                      <span
                        class="fontstylewrapmore-3 tw-mt-3 tw-text-sm title-desc tw-leading-relaxed"
                        >{{ item.desc }}</span
                      >
                    </div>

                    <div class="card-c-btn">
                      <span
                        @click.stop="handleClickRoute(item)"
                        class="tw-py-2 tw-w-full tw-text-center tw-rounded-sm tw-text-white tw-cursor-pointer"
                        >{{ $t("了解更多") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tw-w-full tw-flex tw-items-center tw-justify-center tw-mt-8"
              >
                <span
                  class="tw-text-textLight tw-text-center tw-text-sm tw-cursor-pointer tw-py-2 tw-px-5 tw-border hover:tw-text-primary hover:tw-border-primary"
                  @click="handleClickRoute"
                  style="border-radius: 100px"
                >
                  {{ $t("更多解决方案") }}
                  <b-icon icon="chevron-right" class="tw-w-3 tw-h-3"></b-icon>
                </span>
              </div>
            </div>

            <div
              class="tw-w-24 tw-flex-none tw-flex tw-items-center tw-justify-start tw-pl-3"
            ></div>
          </div>
        </b-col>
        <b-col cols="1"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { solutionsApi } from "@/api/modules/home";
import BigImg from "@/components/skeleton/bigImg.vue";
export default {
  components: {
    BigImg,
  },
  data() {
    return {
      tabsList: [],
      isLoading: true,
      isVisible: false,
      observer: null,
    };
  },
  mounted() {
    const info = JSON.parse(localStorage.getItem("indexInfo"));
    if (info) {
      this.getList();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0, // 当组件10%可见时触发
        }
      );

      this.observer.observe(this.$el);
    },
    getList() {
      solutionsApi({
        pageIndex: 1,
        pageSize: 5,
      }).then((res) => {
        this.tabsList = res.data.list || [];
      });
    },
    handleClickRoute(row) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (row.id) {
        localStorage.setItem("detailForm", JSON.stringify(row));
        this.$router.push({
          path: "/solution/" + row.id + "?isApi=false",
        });
      } else {
        this.$router.push({
          path: "/solution",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

.flex-1 {
  flex: 1;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.solution-container {
  display: flex;
}

.solution-item {
  display: flex;
  height: 400px;
  margin: 10px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;

  &:hover {
    cursor: pointer;
    transform: translateY(-3px);
  }
}

.solution-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.solution-content {
  position: absolute;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #fff;
  height: 100%;
}

.solution-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.solution-desc {
  font-size: 14px;
  margin-bottom: 10px;
}

.solution-link {
  color: #007bff;
  text-decoration: none;
}

.consult-button {
  display: inline-block;
  padding: 6px 12px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid #fff;
  color: white;
  text-decoration: none;
}

.check-btn {
  width: 172px;
  height: 43px;
  line-height: 43px;
  margin: 0 auto;
  border-radius: 5px;
  border: 1px solid #ebebeb;
  cursor: pointer;

  &:hover {
    background: #007bff;
    color: white;
    border: 1px solid #007bff;
  }
}

.card-container {
  display: flex;
  gap: 20px;
  width: 100%;
}

.card {
  height: 460px;
  overflow: hidden;
  position: relative;
  transition: all 0.5s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  flex: 2;
  border-radius: 16px;
  border: none;
}

.card:first-child {
  flex: 4;

  .card-c-btn {
    width: 100%;
    display: flex;
  }

  .card-content {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.9) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
    justify-content: space-between;
    .title {
      color: #333;

      .title-info {
        display: none;
      }

      .title-desc {
        color: #666;
        display: block;
      }
    }
  }
}

.card-container:hover .card:first-child:not(:hover) {
  flex: 2;

  .card-c-btn {
    display: none;
  }

  .card-content {
    justify-content: end;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));

    .title {
      color: white;

      .title-info {
        display: block;
      }

      .title-desc {
        display: none;
      }
    }
  }
}

.card:not(:first-child) {
  .card-content {
    .title {
      .title-info {
        display: block;
      }

      .title-desc {
        display: none;
      }
    }
  }
}

.card-container:hover .card:first-child:not(:hover) {
  flex: 2;

  .card-c-btn {
    display: none;
  }

  .card-content {
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));

    .title {
      color: white;

      .title-info {
        display: block;
      }

      .title-desc {
        display: none;
      }
    }
  }
}

.card:hover {
  flex: 4;

  .card-c-btn {
    width: 100%;
    display: flex;
  }

  .card-content {
    justify-content: space-between;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.9) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );

    .title {
      color: #333;

      .title-info {
        display: none;
      }

      .title-desc {
        color: #666;
        display: block;
      }
    }
  }
}

.card-container:hover .card:not(:hover) {
  flex: 2;

  .card-c-btn {
    display: none;
  }

  .card-content {
    .title {
      .title-info {
        display: block;
      }

      .title-desc {
        display: none;
      }
    }
  }
}

.card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 100%;
  height: 100%;
  padding: 20px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
  color: white;
  border-radius: 10px;
  overflow: hidden;
}

.card-content h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
}

.card-content p {
  margin: 0;
  font-size: 14px;
  opacity: 0.5;
}

.card-c-btn {
  display: none;
  width: 100%;
  font-size: 13px;
  transition: all 0.5s ease;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid #ffffff;
}
</style>
